module.exports = __webpack_public_path__ + "img/20191104162701216.6df03b77.jpg";